/**
 * Caasi Blog — Table of Contents (toc.js)
 *
 * - Pakt automatisch alle H2-elementen uit het artikel
 * - Toont de TOC alleen als er ≥2 H2s aanwezig zijn
 * - Vult BEIDE TOC-elementen: sidebar (desktop) + inline (mobiel)
 * - Voegt smooth scroll toe bij klik
 * - Markeert de actieve sectie op basis van scroll-positie (IntersectionObserver)
 * - Genereert unieke id-attributen als H2s die nog geen id hebben
 */

(function () {
  'use strict';

  var CONTENT_SELECTOR = '.article-template__content, .rte, [data-article-content], .article__content';
  var TOC_INSTANCES = [
    { wrapper: '#caasi-toc',        list: '#caasi-toc-list' },
    { wrapper: '#caasi-toc-mobile', list: '#caasi-toc-list-mobile' }
  ];
  var MIN_HEADINGS = 2;

  function slugify(text) {
    return text
      .toString()
      .toLowerCase()
      .trim()
      .replace(/[\s\W-]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function init() {
    /* Vind alle actieve TOC-containers */
    var tocPairs = [];
    TOC_INSTANCES.forEach(function (inst) {
      var wrapper = document.querySelector(inst.wrapper);
      var list    = document.querySelector(inst.list);
      if (wrapper && list) {
        tocPairs.push({ wrapper: wrapper, list: list });
      }
    });
    if (tocPairs.length === 0) return;

    /* Zoek de artikel-content container */
    var contentEl = null;
    var selectors = CONTENT_SELECTOR.split(',');
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i].trim());
      if (el) { contentEl = el; break; }
    }
    if (!contentEl) return;

    /* Verzamel alle H2-elementen */
    var headings = Array.prototype.slice.call(contentEl.querySelectorAll('h2'));
    if (headings.length < MIN_HEADINGS) return;

    /* Zorg dat elke H2 een uniek id heeft */
    var usedIds = {};
    headings.forEach(function (h2) {
      if (!h2.id) {
        var base  = slugify(h2.textContent);
        var id    = base;
        var count = 1;
        while (usedIds[id]) {
          id = base + '-' + (++count);
        }
        h2.id = id;
      }
      usedIds[h2.id] = true;
    });

    /* Bouw de lijst voor ELKE TOC-container */
    tocPairs.forEach(function (pair) {
      var fragment = document.createDocumentFragment();
      headings.forEach(function (h2) {
        var li   = document.createElement('li');
        var link = document.createElement('a');
        link.href        = '#' + h2.id;
        link.textContent = h2.textContent;
        link.className   = 'caasi-toc__link';
        link.dataset.tocTarget = h2.id;

        link.addEventListener('click', function (e) {
          e.preventDefault();
          var target = document.getElementById(h2.id);
          if (!target) return;
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          if (window.history && window.history.pushState) {
            window.history.pushState(null, '', '#' + h2.id);
          }
        });

        li.appendChild(link);
        fragment.appendChild(li);
      });

      pair.list.appendChild(fragment);
      pair.wrapper.style.display = 'block';
    });

    /* Actieve sectie markeren via IntersectionObserver */
    if ('IntersectionObserver' in window) {
      var activeId = null;

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              activeId = entry.target.id;
            }
          });
          updateActiveLinks(activeId);
        },
        {
          rootMargin: '0px 0px -60% 0px',
          threshold: 0
        }
      );

      headings.forEach(function (h2) {
        observer.observe(h2);
      });
    }

    function updateActiveLinks(id) {
      /* Update actieve link in ALLE TOC-containers */
      tocPairs.forEach(function (pair) {
        var links = pair.list.querySelectorAll('.caasi-toc__link');
        links.forEach(function (link) {
          if (link.dataset.tocTarget === id) {
            link.classList.add('caasi-toc__link--active');
          } else {
            link.classList.remove('caasi-toc__link--active');
          }
        });
      });
    }
  }

  /* Wacht op DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
